import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function AboutSection() {
  useScrollAnimation();

  return (
    <section id="about" className="bg-white py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Images */}
        <div className="relative animate-on-scroll">
          {/* Main large image */}
          <div className="relative w-full aspect-[4/5] max-w-[420px] mx-auto lg:mx-0 overflow-hidden rounded-2xl">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/bhodevcameroon.appspot.com/o/company-assets%2Fbhodev-cameroon.jpeg?alt=media&token=b5e85b13-54f4-4afe-960e-c331bd3b0cf7"
              alt="BHODEV workers serving the community"
              title="BHODEV workers serving the community"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Floating small image */}
          <div className="absolute -bottom-6 -right-4 lg:right-8 w-[40%] max-w-[180px] aspect-square bg-white p-2 rounded-2xl shadow-xl">
            <img
              src="https://storage.readdy-site.link/project_files/4e9a12fb-cddb-4082-86d9-a8d48c5e1af1/4c1dbfd3-51c3-4b4d-bce2-d21c130722c0_LOGO---BHODEV.jpeg?v=bec7ea05bbbc33a50ca492c9bcdd08aa"
              alt="Make a change"
              title="BHODEV community empowerment"
              className="w-full h-full object-cover object-top rounded-xl"
            />
          </div>
          {/* Decorative badge */}
          <div className="absolute top-6 -left-4 lg:left-4 bg-primary text-white px-4 py-2 rounded-full text-xs font-inter font-semibold shadow-lg shadow-primary/30 whitespace-nowrap">
            <i className="ri-heart-fill mr-1"></i>
            Make a change
          </div>
        </div>

        {/* Text Content */}
        <div className="flex flex-col items-start justify-center animate-on-scroll animate-on-scroll-delay-1">
          <span className="px-4 py-1.5 rounded-full bg-secondary text-primary text-xs font-inter font-semibold mb-5 tracking-wide uppercase">
            About Us
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-saria font-bold text-dark mb-6 leading-tight">
            Community Health at Heart
          </h2>

          <div className="bg-stone-50 p-5 mb-6 border-l-4 border-primary rounded-r-xl w-full">
            <p className="text-dark/80 text-sm leading-relaxed italic">
              &ldquo;We strive to create an empowered community that provides good health for all.&rdquo;
            </p>
            <p className="text-primary font-semibold text-sm mt-2">&mdash; BHODEV Cameroon</p>
          </div>

          <p className="text-stone-600 text-sm md:text-base leading-relaxed mb-8">
            Bogi Health Organization for Development (BHODEV) is an NGO working to promote health, peace, social justice &amp; sustainable development in Cameroon, founded in 2014 and legalized in 2019. BHODEV was founded by a group of medical doctors, nurses, entrepreneurs and psychologists who were concerned with the predicament of the rural communities especially the interior and inaccessible areas making the inhabitants vulnerable such as persons with disabilities, displaced women and children, widows, orphans, school dropouts, minority groups who are all beneficiary of our programs.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="#about"
              className="bg-primary text-white px-6 py-3 rounded-full hover:bg-primary-dark transition-all duration-300 font-inter font-semibold text-sm whitespace-nowrap cursor-pointer shadow-lg shadow-primary/20 hover:shadow-primary/40"
            >
              Learn more
            </a>
            <a
              href="#contact"
              className="bg-transparent text-primary px-6 py-3 rounded-full border-2 border-primary hover:bg-primary hover:text-white transition-all duration-300 font-inter font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              Contact us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}